// Increase Rules Internationalization File
export default {
  salesConflict: {
    title: 'Duplicate rules: {count} conflicts', save: 'Nothing was saved. Your entries are still here.',
    enable: 'None of the selected rules were enabled. Resolve the conflicts below first.',
    rule: 'Submitted rule', type: 'Business type', existingRule: 'Conflicting rule', priority: 'Priority',
    period: 'Conflicting rule validity (UTC)', channels: 'Overlapping channels', action: 'Action',
    withinBatch: 'Conflict within this batch', view: 'View rule', close: 'Close'
  },
  salesList: {
    details: 'Details', amount: 'Amount', percentage: 'Percentage', from: 'From', until: 'Until',
    amountUnitHint: 'Currency and billing units follow the matched rate.'
  },
  salesPhaseTwo: {
    tabs: { sea: 'Ocean', preport: 'Pre-port', lastmile: 'Last mile', rail: 'Rail', express: 'Express', air: 'Air' },
    seaTypes: 'Ocean types', beginDate: 'Effective from (UTC)', endDate: 'Effective until (UTC)',
    remark: 'Remark', customers: 'Customers', conditions: 'Conditions', channels: 'Channel markups',
    validity: 'Effective date range (UTC)', unlimited: 'Unrestricted', retry: 'Retry',
    noConditions: 'No rate conditions. Rates within the customer scope can match.',
    multipleMethods: 'Use multiple billing methods',
    channelNames: { cargoWareX: 'CargoWareX', family: 'Family' },
    validation: {
      types: 'Select a business type. Only ocean types can be created together.',
      channels: 'Select at least one channel.', name: 'Enter a rule name of up to 50 characters.',
      priority: 'Priority must be an integer greater than or equal to zero.', scope: 'Select customers or customer levels.',
      dates: 'Check validity. The end must not precede the start.',
      conditions: 'Complete all conditions. A maximum of 20 is allowed.',
      unsupportedCondition: 'A condition is unsupported by a selected type. Adjust the types or conditions.',
      amount: 'Complete the markup configuration for each selected type and channel.'
    }
  },
  // Module title and description
  title: 'Increase Rules',
  description: 'Manage various increase rules information',

  // Tab navigation
  tabs: {
    fcl: 'FCL Increase Rules',
    preport: 'Pre-port Increase Rules',
    lastmile: 'Last Mile Increase Rules'
  },

  // FCL Increase Rules Management
  fcl: {
    // Page titles
    title: 'FCL Increase Rules Management',
    description: 'Manage FCL increase rules information',
    createTitle: 'Add FCL Increase Rule',
    editTitle: 'Edit FCL Increase Rule',
    viewTitle: 'View FCL Increase Rule Details',

    // Toolbar buttons
    toolbar: {
      addRule: 'Add Rule',
      batchEnable: 'Batch Enable',
      batchDisable: 'Batch Disable'
    },

    // Table column headers
    columns: {
      rulesId: 'Rule ID',
      rulesType: 'Rule Type',
      laneIds: 'Routes',
      carrierIds: 'Carriers',
      pols: 'Port of Loading',
      pods: 'Port of Discharge',
      chargeItemId: 'Charge Item',
      currency: 'Currency',
      measure: 'Billing Unit',
      enableFlag: 'Status',
      createdBy: 'Created By',
      modifiedBy: 'Modified By',
      dateCreated: 'Created Date',
      dateModified: 'Modified Date',
      actions: 'Actions'
    },

    // Action buttons
    actions: {
      view: 'Details',
      edit: 'Edit',
      more: 'More',
      enable: 'Enable',
      disable: 'Disable'
    },

    // Status text
    status: {
      enabled: 'Enabled',
      disabled: 'Disabled',
      unknown: 'Unknown'
    },

    // Rule type text
    rulesType: {
      1: 'FCL Ocean Freight',
      2: 'Pre-port Rate',
      3: 'Last Mile Rate',
      4: 'LCL Ocean Freight',
      5: 'Air Freight',
      unknown: 'Unknown'
    },

    // Batch operation confirmation messages
    batch: {
      singleConfirmTitle: '{action} Confirmation',
      singleConfirmContent: 'Are you sure you want to {action} this fcl increase rule?',
      enableConfirm: 'Batch Enable Confirmation',
      disableConfirm: 'Batch Disable Confirmation',
      enableMessage: 'Are you sure you want to enable the selected {count} rules?',
      disableMessage: 'Are you sure you want to disable the selected {count} rules?',
      singleEnableMessage: 'Are you sure you want to enable this rule?',
      singleDisableMessage: 'Are you sure you want to disable this rule?',
      successEnable: 'Enabled successfully',
      successDisable: 'Disabled successfully',
      successBatchEnable: 'Successfully enabled {count} rules',
      successBatchDisable: 'Successfully disabled {count} rules',
      failedEnable: 'Enable failed',
      failedDisable: 'Disable failed',
      failedBatchEnable: 'Batch enable failed',
      failedBatchDisable: 'Batch disable failed'
    },

    // Message prompts
    messages: {
      selectEnableRules: 'Please select rules to enable first',
      selectDisableRules: 'Please select rules to disable first',
      loadDataFailed: 'Failed to load data',
      unknownError: 'Unknown error',
      missingRecordId: 'Cannot view details: Missing record ID',
      missingEditId: 'Cannot edit: Missing record ID',
      clickTabToLoad: 'Click {tab} tab to load content'
    },

    // Export related
    export: {
      filename: 'Increase Rules List',
      columns: {
        rulesId: 'Rule ID',
        rulesType: 'Rule Type',
        laneIds: 'Routes',
        carrierIds: 'Carriers',
        pols: 'Port of Loading',
        pods: 'Port of Discharge',
        chargeItemName: 'Charge Item',
        currencyName: 'Currency',
        measure: 'Billing Unit',
        enableFlag: 'Status',
        dateCreated: 'Created Date',
        dateModified: 'Modified Date'
      }
    },

    // Billing units display
    billingUnits: {
      allUnits: 'All Billing Units',
      moreUnits: '+{count}'
    },

    // Export data units
    exportUnits: {
      routes: ' routes',
      carriers: ' carriers',
      pols: ' ports of loading',
      pods: ' ports of discharge',
      billingUnits: ' billing units'
    }
  },

  // Pre-port increase rules management
  preport: {
    title: 'Pre-port Increase Rules Management',
    description: 'Manage pre-port increase rules information',
    createTitle: 'Add Pre-port Increase Rule',
    editTitle: 'Edit Pre-port Increase Rule',
    viewTitle: 'View Pre-port Increase Rule Details',

    // Toolbar buttons
    toolbar: {
      addRule: 'Add Rule',
      batchEnable: 'Batch Enable',
      batchDisable: 'Batch Disable'
    },

    // Table column headers
    columns: {
      rulesId: 'Rule ID',
      rulesType: 'Rule Type',
      pols: 'Port of Loading',
      pods: 'Port of Discharge',
      priceMethod: 'Price Method',
      branchLines: 'Branch Line Type',
      regions: 'Origin Region',
      chargeItemId: 'Charge Item',
      currency: 'Currency',
      measure: 'Billing Unit',
      enableFlag: 'Status',
      createdBy: 'Created By',
      modifiedBy: 'Modified By',
      dateCreated: 'Created Date',
      dateModified: 'Modified Date',
      actions: 'Actions'
    },
    pols: {
      popoverTitle: 'Port of Loading'
    },
    regions: {
      totalRegions: 'Total {count} origin regions'
    },

    // Action buttons
    actions: {
      view: 'Details',
      edit: 'Edit',
      more: 'More',
      enable: 'Enable',
      disable: 'Disable'
    },

    // Status text
    status: {
      enabled: 'Enabled',
      disabled: 'Disabled',
      unknown: 'Unknown'
    },

    // Rule type text
    rulesType: {
      1: 'FCL Ocean Freight',
      2: 'Pre-port Rate',
      3: 'Last Mile Rate',
      4: 'LCL Ocean Freight',
      5: 'Air Freight',
      unknown: 'Unknown'
    },

    // Price method text
    priceMethod: {
      1: 'Direct',
      2: 'Branch Line',
      3: 'Sea-Rail',
      direct: 'Direct',
      branchLine: 'Branch Line',
      seaRail: 'Sea-Rail',
      unknown: 'Unknown'
    },

    // Branch line type text
    branchLines: {
      1: 'Railway',
      2: 'Highway',
      3: 'Inland Waterway',
      allTypesTooltip: 'All Branch Line Types',
      unknown: 'Unknown'
    },

    // Batch operation confirmation messages
    batch: {
      enableConfirm: 'Batch Enable Confirmation',
      disableConfirm: 'Batch Disable Confirmation',
      enableMessage: 'Are you sure you want to enable the selected {count} rules?',
      disableMessage: 'Are you sure you want to disable the selected {count} rules?',
      singleConfirmTitle: '{action} Confirmation',
      singleConfirmContent: 'Are you sure you want to {action} this pre-port increase rule?',
      singleEnableMessage: 'Are you sure you want to enable this rule?',
      singleDisableMessage: 'Are you sure you want to disable this rule?',
      successEnable: 'Enabled successfully',
      successDisable: 'Disabled successfully',
      successBatchEnable: 'Successfully enabled {count} rules',
      successBatchDisable: 'Successfully disabled {count} rules',
      failedEnable: 'Enable failed',
      failedDisable: 'Disable failed',
      failedBatchEnable: 'Batch enable failed',
      failedBatchDisable: 'Batch disable failed'
    },

    // Message prompts
    messages: {
      selectEnableRules: 'Please select rules to enable first',
      selectDisableRules: 'Please select rules to disable first',
      loadDataFailed: 'Failed to load data',
      unknownError: 'Unknown error',
      missingRecordId: 'Cannot view details: Missing record ID',
      missingEditId: 'Cannot edit: Missing record ID',
      clickTabToLoad: 'Click {tab} tab to load content'
    },

    // Export related
    export: {
      filename: 'Pre-port Increase Rules List',
      columns: {
        rulesId: 'Rule ID',
        rulesType: 'Rule Type',
        pols: 'Port of Loading',
        pods: 'Port of Discharge',
        priceMethod: 'Price Method',
        branchLines: 'Branch Line Type',
        regions: 'Origin Region',
        chargeItemName: 'Charge Item',
        currencyName: 'Currency',
        measure: 'Billing Unit',
        enableFlag: 'Status',
        dateCreated: 'Created Date',
        dateModified: 'Modified Date'
      }
    },

    // Billing units display
    billingUnits: {
      allUnits: 'All Billing Units',
      moreUnits: '+{count}'
    },

    // Export data units
    exportUnits: {
      pols: ' ports of loading',
      pods: ' ports of discharge',
      branchLines: ' branch line types',
      billingUnits: ' billing units'
    }
  },

  // Last mile increase rules management
  lastmile: {
    title: 'Last Mile Increase Rules Management',
    description: 'Manage last mile increase rules information',
    createTitle: 'Add Last Mile Increase Rule',
    editTitle: 'Edit Last Mile Increase Rule',
    viewTitle: 'View Last Mile Increase Rule Details',

    // Toolbar buttons
    toolbar: {
      addRule: 'Add Rule',
      batchEnable: 'Batch Enable',
      batchDisable: 'Batch Disable'
    },

    // Table column headers
    columns: {
      rulesId: 'Rule ID',
      rulesType: 'Rule Type',
      pods: 'Port of Discharge',
      regions: 'Delivery Address',
      addressType: 'Address Type',
      warehouseCode: 'Warehouse Code',
      chargeItemId: 'Charge Item',
      currency: 'Currency',
      measure: 'Billing Unit',
      enableFlag: 'Status',
      createdBy: 'Created By',
      modifiedBy: 'Modified By',
      dateCreated: 'Created Date',
      dateModified: 'Modified Date',
      actions: 'Actions'
    },

    // Action buttons
    actions: {
      view: 'Details',
      edit: 'Edit',
      more: 'More',
      enable: 'Enable',
      disable: 'Disable'
    },

    // Status text
    status: {
      enabled: 'Enabled',
      disabled: 'Disabled',
      unknown: 'Unknown'
    },

    // Rule type text
    rulesType: {
      1: 'FCL Ocean Freight',
      2: 'Pre-port Rate',
      3: 'Last Mile Rate',
      4: 'LCL Ocean Freight',
      5: 'Air Freight',
      unknown: 'Unknown'
    },

    // Address type text
    addressType: {
      1: 'Third-party Address',
      2: 'Self-operated Address',
      unknown: 'Unknown'
    },

    // Batch operation confirmation messages
    batch: {
      singleConfirmTitle: '{action} Confirmation',
      singleConfirmContent: 'Are you sure you want to {action} this last-mile increase rule?',
      enableConfirm: 'Batch Enable Confirmation',
      disableConfirm: 'Batch Disable Confirmation',
      enableMessage: 'Are you sure you want to enable the selected {count} rules?',
      disableMessage: 'Are you sure you want to disable the selected {count} rules?',
      singleEnableMessage: 'Are you sure you want to enable this rule?',
      singleDisableMessage: 'Are you sure you want to disable this rule?',
      successEnable: 'Enabled successfully',
      successDisable: 'Disabled successfully',
      successBatchEnable: 'Successfully enabled {count} rules',
      successBatchDisable: 'Successfully disabled {count} rules',
      failedEnable: 'Enable failed',
      failedDisable: 'Disable failed',
      failedBatchEnable: 'Batch enable failed',
      failedBatchDisable: 'Batch disable failed'
    },

    // Message prompts
    messages: {
      selectEnableRules: 'Please select rules to enable first',
      selectDisableRules: 'Please select rules to disable first',
      loadDataFailed: 'Failed to load data',
      unknownError: 'Unknown error',
      missingRecordId: 'Cannot view details: Missing record ID',
      missingEditId: 'Cannot edit: Missing record ID',
      clickTabToLoad: 'Click {tab} tab to load content'
    },

    // Export related
    export: {
      filename: 'Last Mile Increase Rules List',
      columns: {
        rulesId: 'Rule ID',
        rulesType: 'Rule Type',
        regions: 'Delivery Address',
        chargeItemName: 'Charge Item',
        currencyName: 'Currency',
        measure: 'Billing Unit',
        enableFlag: 'Status',
        dateCreated: 'Created Date',
        dateModified: 'Modified Date'
      }
    },

    // Billing units display
    billingUnits: {
      allUnits: 'All Billing Units',
      moreUnits: '+{count}'
    },

    // Export data units
    exportUnits: {
      regions: ' delivery addresses',
      billingUnits: ' billing units'
    }
  },

  // Detail page
  detail: {
    // Page titles
    createTitle: 'Add Increase Rule',
    editTitle: 'Edit Increase Rule',
    viewTitle: 'Increase Rule Details',
    copyTitle: 'Copy Increase Rule',

    // Basic information
    basicInfo: 'Basic Information',
    laneName: 'Route Name',
    carrier: 'Carrier',
    pol: 'Port of Loading',
    pod: 'Port of Discharge',
    chargeItem: 'Charge Item',
    currency: 'Currency',
    billingUnit: 'Billing Unit',
    ruleStatus: 'Rule Status',
    remarks: 'Remarks',

    // Billing unit rules configuration
    billingUnitRules: 'Billing Unit Rules Configuration',
    selectFeeFirst: 'Please select fee name first, system will automatically generate corresponding billing unit rules',
    noBillingUnits: 'The selected fee name has no available billing units',

    // Table column headers
    columns: {
      billingUnit: 'Billing Unit',
      t0Price: 'T0 Price',
      t1Price: 'T1 Price',
      t2Price: 'T2 Price',
      t3Price: 'T3 Price',
      internalSales: 'Internal Sales'
    },

    // Placeholders
    placeholders: {
      selectLane: 'Please select route name',
      selectCarrier: 'Please select carrier',
      selectPol: 'Please select port of loading',
      selectPod: 'Please select port of discharge',
      selectChargeItem: 'Please select charge item',
      selectCurrency: 'Please select currency',
      selectBillingUnit: 'Please select billing unit',
      enterRemarks: 'Please enter remarks',
      enterT0Price: 'Please enter T0 price',
      enterT1Price: 'Please enter T1 price',
      enterT2Price: 'Please enter T2 price',
      enterT3Price: 'Please enter T3 price',
      enterInternalSales: 'Please enter internal sales price',
      autoSetByFee: 'Automatically set by fee name'
    },

    // Buttons
    back: 'Back',
    save: 'Save',
    edit: 'Edit',
    copy: 'Copy',

    // Copy tip
    copyTip: 'Copying increase rule information, rule number will be automatically regenerated, please confirm all information before saving',

    // Validation messages
    validation: {
      selectFeeRequired: 'Please select fee name',
      selectCurrencyRequired: 'Please select currency'
    },

    // Success messages
    messages: {
      copySuccess: 'Increase rule information has been copied to the add page, rule number will be regenerated, please confirm the information before saving',
      saveSuccess: 'Increase rule created successfully!',
      updateSuccess: 'Increase rule updated successfully!',
      saveFailed: 'Save failed',
      loadDataFailed: 'Failed to load data',
      copyDataFailed: 'Failed to load copy data',
      checkRequired: 'Please check required fields'
    }
  },

  // Pre-port increase rules detail page
  preportDetail: {
    // Page titles
    createTitle: 'Add Pre-port Increase Rule',
    editTitle: 'Edit Pre-port Increase Rule',
    viewTitle: 'Pre-port Increase Rule Details',
    copyTitle: 'Copy Pre-port Increase Rule',

    // Basic information
    basicInfo: 'Basic Information',
    priceMethod: 'Price Method',
    priceMethodDirect: 'Direct',
    priceMethodBranch: 'Branch Line',
    priceMethodRail: 'Sea-Rail',
    branchLines: 'Branch Line Type',
    branchLineRailway: 'Railway',
    branchLineHighway: 'Highway',
    branchLineWaterway: 'Inland Waterway',
    pols: 'Port of Loading',
    regions: 'Origin Region',
    chargeItem: 'Charge Item',
    currency: 'Currency',
    billingUnit: 'Billing Unit',
    ruleStatus: 'Rule Status',

    // Billing unit rules configuration
    billingUnitRules: 'Billing Unit Rules Configuration',
    selectFeeFirst: 'Please select fee name first, system will automatically generate corresponding billing unit rules',
    noBillingUnits: 'The selected fee name has no available billing units',

    // Table column headers
    columns: {
      billingUnit: 'Billing Unit',
      t0Price: 'T0 Price',
      t1Price: 'T1 Price',
      t2Price: 'T2 Price',
      t3Price: 'T3 Price',
      internalSales: 'Internal Sales'
    },

    // Placeholders
    placeholders: {
      selectPriceMethod: 'Please select price method',
      selectBranchLines: 'Please select branch line type',
      selectPols: 'Please select port of loading',
      selectRegions: 'Please select origin region',
      selectChargeItem: 'Please select charge item',
      selectCurrency: 'Please select currency',
      selectBillingUnit: 'Please select billing unit',
      enterT0Price: 'Please enter T0 price',
      enterT1Price: 'Please enter T1 price',
      enterT2Price: 'Please enter T2 price',
      enterT3Price: 'Please enter T3 price',
      enterInternalSales: 'Please enter internal sales price',
      autoSetByFee: 'Automatically set by fee name'
    },

    // Buttons
    back: 'Back',
    save: 'Save',
    edit: 'Edit',
    copy: 'Copy',

    // Copy tip
    copyTip: 'Copying pre-port increase rule information, rule number will be automatically regenerated, please confirm all information before saving',

    // Validation messages
    validation: {
      selectPriceMethodRequired: 'Please select price method',
      selectBranchLinesRequired: 'Please select branch line type',
      selectPolsRequired: 'Please select port of loading',
      selectChargeItemRequired: 'Please select charge item',
      selectCurrencyRequired: 'Please select currency'
    },

    // Success messages
    messages: {
      copySuccess: 'Pre-port increase rule information has been copied to the add page, rule number will be regenerated, please confirm the information before saving',
      saveSuccess: 'Pre-port increase rule created successfully!',
      updateSuccess: 'Pre-port increase rule updated successfully!',
      saveFailed: 'Save failed',
      loadDataFailed: 'Failed to load data',
      copyDataFailed: 'Failed to load copy data',
      checkRequired: 'Please check required fields',
      unknownError: 'Unknown error'
    },

    // Status text
    status: {
      enabled: 'Enabled',
      disabled: 'Disabled',
      expired: 'Expired'
    },

    // Additional internationalization keys
    aiRecognition: 'AI Recognition',
    addRegion: 'Add Region',
    province: 'Province',
    city: 'City',
    district: 'District/County',
    street: 'Street',
    community: 'Community',
    operation: 'Operation',
    delete: 'Delete',
    selectProvince: 'Please select province',
    selectCity: 'Please select city',
    selectDistrict: 'Please select district/county',
    selectStreet: 'Please select street',
    selectCommunity: 'Please select community',

    // Country related
    countryChina: 'China'
  },

  // Last mile increase rules detail page
  lastmileDetail: {
    // Page titles
    createTitle: 'Add Last Mile Increase Rule',
    editTitle: 'Edit Last Mile Increase Rule',
    viewTitle: 'Last Mile Increase Rule Details',
    copyTitle: 'Copy Last Mile Increase Rule',

    // Basic information
    basicInfo: 'Basic Information',
    pods: 'Port of Discharge',
    regions: 'Delivery Address',
    addressType: 'Address Type',
    addressTypeThirdParty: 'Third-party Address',
    addressTypeSelfOperated: 'Self-operated Address',
    warehouseCode: 'Warehouse Code',
    chargeItem: 'Charge Item',
    currency: 'Currency',
    billingUnit: 'Billing Unit',
    ruleStatus: 'Rule Status',

    // Billing unit rules configuration
    billingUnitRules: 'Billing Unit Rules Configuration',
    selectFeeFirst: 'Please select fee name first, system will automatically generate corresponding billing unit rules',
    noBillingUnits: 'The selected fee name has no available billing units',

    // Table column headers
    columns: {
      billingUnit: 'Billing Unit',
      t0Price: 'T0 Price',
      t1Price: 'T1 Price',
      t2Price: 'T2 Price',
      t3Price: 'T3 Price',
      internalSales: 'Internal Sales'
    },

    // Placeholders
    placeholders: {
      selectPods: 'Please select port of discharge',
      selectRegions: 'Please select delivery address',
      selectChargeItem: 'Please select charge item',
      selectCurrency: 'Please select currency',
      selectBillingUnit: 'Please select billing unit',
      enterT0Price: 'Please enter T0 price',
      enterT1Price: 'Please enter T1 price',
      enterT2Price: 'Please enter T2 price',
      enterT3Price: 'Please enter T3 price',
      enterInternalSales: 'Please enter internal sales price'
    },

    // Buttons
    back: 'Back',
    save: 'Save',
    edit: 'Edit',
    copy: 'Copy',

    // Copy tip
    copyTip: 'Copying last mile increase rule information, rule number will be automatically regenerated, please confirm all information before saving',

    // Validation messages
    validation: {
      selectPodsRequired: 'Please select port of discharge',
      selectChargeItemRequired: 'Please select charge item',
      selectCurrencyRequired: 'Please select currency'
    },

    // Success messages
    messages: {
      copySuccess: 'Last mile increase rule information has been copied to the add page, rule number will be regenerated, please confirm the information before saving',
      saveSuccess: 'Last mile increase rule created successfully!',
      updateSuccess: 'Last mile increase rule updated successfully!',
      saveFailed: 'Save failed',
      loadDataFailed: 'Failed to load data',
      copyDataFailed: 'Failed to load copy data',
      checkRequired: 'Please check required fields',
      unknownError: 'Unknown error'
    },

    // Status text
    status: {
      enabled: 'Enabled',
      disabled: 'Disabled'
    },

    // New internationalization keys
    aiRecognition: 'AI Recognition',
    addRegion: 'Add Region',
    addressTypeLabel: 'Address Type',
    thirdPartyAddress: 'Third-party Address',
    amazonWarehouse: 'Amazon Warehouse',
    easyWarehouse: 'Easy Warehouse',
    country: 'Country',
    state: 'State',
    city: 'City',
    region: 'Region',
    warehouseCodeLabel: 'Warehouse Code',
    easyWarehouseCode: 'Easy Warehouse Code',
    operation: 'Operation',
    delete: 'Delete',
    selectAddressType: 'Please select address type',
    selectCountry: 'Please select country',
    selectState: 'Please select state',
    selectCity: 'Please select city',
    selectRegion: 'Please select region',
    selectAmazonWarehouse: 'Please select Amazon warehouse',
    selectEasyWarehouse: 'Please select Easy warehouse',
    selectChargeItem: 'Please select charge item',
    selectBillingUnit: 'Please select billing unit',
    autoSetByFee: 'Automatically set by fee name',
    enterT0Price: 'Please enter T0 price',
    enterT1Price: 'Please enter T1 price',
    enterT2Price: 'Please enter T2 price',
    enterT3Price: 'Please enter T3 price',
    enterInternalSalesPrice: 'Please enter internal sales price'
  },

  // Common text
  common: {
    loading: 'Loading...',
    noData: 'No data',
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    view: 'View',
    enable: 'Enable',
    disable: 'Disable',
    copy: 'Copy',
    back: 'Back',
    submit: 'Submit',
    reset: 'Reset',
    search: 'Search',
    filter: 'Filter',
    export: 'Export',
    import: 'Import',
    refresh: 'Refresh',
    close: 'Close',
    ok: 'OK',
    yes: 'Yes',
    no: 'No'
  },
  filterPlaceholders: {
    enterRulesId: 'Please enter Rule ID',
    selectPriceMethod: 'Please select price method',
    selectBranchLines: 'Please select branch line type',
    selectPol: 'Please select port of loading',
    selectPod: 'Please select port of discharge',
    selectChargeItem: 'Please select charge item',
    selectCurrency: 'Please select currency',
    selectBillingUnit: 'Please select billing unit',
    selectEnableFlag: 'Please select status',
    selectRuleStatus: 'Please select rule status',
    selectDateCreated: 'Please select creation date',
    selectDateModified: 'Please select modification date',
    selectDateCreatedRange: 'Please select creation date range',
    selectDateModifiedRange: 'Please select modification date range',
    enterCreatedBy: 'Please enter created by',
    enterModifiedBy: 'Please enter modified by',
    enterWarehouseCode: 'Please enter warehouse code',
    selectAddressType: 'Please select address type',
    selectRulesType: 'Please select rule type'
  },

  // Enum labels
  enums: {
    conditionField: {
      carrier: 'Carrier',
      pol: 'POL (Port of Loading)',
      pod: 'POD (Port of Discharge)',
      routeCategory: 'Route Category',
      supplier: 'Supplier',
      contractNo: 'Contract No.',
      nac: 'NAC',
      cargoType: 'Cargo Type'
    },
    conditionOperator: {
      include: 'Include',
      eq: 'Equal',
      notInclude: 'Not Include',
      neq: 'Not Equal'
    },
    increasePriceType: {
      percent: 'By Percentage',
      amount: 'By Amount'
    }
  },

  // Business Increase Rules List
  businessFcl: {
    exportFilename: 'Business Increase Rules List',
    toolbar: {
      addRule: 'Add Rule',
      batchEnableCount: 'Batch Enable ({count})',
      batchDisableCount: 'Batch Disable ({count})',
      batchDeleteCount: 'Batch Delete ({count})'
    },
    columns: {
      officeIds: 'Branch Company',
      rulesId: 'Rule ID',
      ruleName: 'Rule Name',
      rulePriority: 'Priority',
      increasePriceType: 'Markup Type',
      enable: 'Status',
      validDate: 'Valid Period',
      createdBy: 'Created By',
      modifiedBy: 'Modified By',
      dateCreated: 'Created Date',
      dateModified: 'Modified Date',
      actions: 'Actions'
    },
    status: {
      enabled: 'Enabled',
      disabled: 'Disabled'
    },
    placeholders: {
      increasePriceType: 'Please Select Markup Type'
    },
    increasePriceType: {
      percent: 'By Percentage',
      amount: 'By Amount'
    },
    actions: {
      view: 'View',
      edit: 'Edit',
      more: 'More',
      copy: 'Copy',
      delete: 'Delete'
    },
    modal: {
      confirmEnable: 'Confirm Enable',
      confirmDisable: 'Confirm Disable',
      enableContent: 'Are you sure you want to enable this rule?',
      disableContent: 'Are you sure you want to disable this rule?',
      deleteTitle: 'Confirm Delete',
      deleteContent: 'Are you sure you want to delete this rule? This action cannot be undone.',
      deleteOkText: 'Confirm Delete',
      batchEnableTitle: 'Batch Enable Confirmation',
      batchEnableContent: 'Are you sure you want to enable the selected {count} rule(s)?',
      batchDisableTitle: 'Batch Disable Confirmation',
      batchDisableContent: 'Are you sure you want to disable the selected {count} rule(s)?',
      batchDeleteTitle: 'Batch Delete Confirmation',
      batchDeleteContent: 'Are you sure you want to delete the selected {count} rule(s)? This action cannot be undone.',
      batchDeleteOkText: 'Confirm Delete',
      confirm: 'Confirm',
      cancel: 'Cancel'
    },
    messages: {
      enableSuccess: 'Enabled successfully',
      disableSuccess: 'Disabled successfully',
      deleteSuccess: 'Operation successful',
      batchEnableSuccess: 'Successfully enabled {count} rule(s)',
      batchDisableSuccess: 'Successfully disabled {count} rule(s)',
      batchDeleteSuccess: 'Successfully deleted {count} rule(s)',
      selectEnableRules: 'Please select rules to enable first',
      selectDisableRules: 'Please select rules to disable first',
      selectDeleteRules: 'Please select rules to delete first'
    },
    export: {
      columns: {
        rulesId: 'Rule ID',
        ruleName: 'Rule Name',
        rulePriority: 'Priority',
        increasePriceType: 'Markup Type',
        enable: 'Status',
        validDate: 'Valid Period',
        dateCreated: 'Created Date',
        dateModified: 'Modified Date'
      }
    }
  },

  // Business Increase Rules Detail
  businessFclDetail: {
    pageTitle: {
      copy: 'Copy Business Increase Rule',
      create: 'Add Business Increase Rule',
      edit: 'Edit Business Increase Rule',
      view: 'Business Increase Rule Detail'
    },
    ruleStatus: 'Rule Status:',
    status: {
      enabled: 'Enabled',
      disabled: 'Disabled',
      expired: 'Expired'
    },
    buttons: {
      back: 'Back',
      save: 'Save',
      edit: 'Edit',
      copy: 'Copy'
    },
    copyAlert: 'Copying business increase rule. The rule ID will be auto-generated. Please verify all information before saving.',
    basicInfo: {
      title: 'Basic Information',
      ruleId: 'Rule ID',
      ruleName: 'Rule Name',
      rulePriority: 'Priority',
      officeIds: 'Branch Company',
      beginDate: 'Valid From',
      endDate: 'Valid To'
    },
    placeholders: {
      ruleName: 'Please enter rule name',
      rulePriority: 'Higher value = higher priority, default 1',
      officeIds: 'Please select branch company',
      beginDate: 'Please select start date',
      endDate: 'Please select end date',
      condField: 'Please select field',
      condValue: 'Please select',
      condValueInput: 'Please enter',
      markupPercent: 'Please enter percentage',
      markupBoxAmount: 'Please enter'
    },
    validation: {
      ruleName: 'Please enter rule name',
      rulePriority: 'Please enter rule priority',
      officeIds: 'Please select branch company',
      beginDate: 'Please select valid from date',
      endDate: 'Please select valid to date',
      condValue: 'This field is required'
    },
    hints: {
      rulePriority: 'Higher value = higher priority, default 1',
      markupPercent: 'Selling Price = Cost × (1 + Markup%)',
      markupBoxAmount: 'Selling Price = Cost + Box Type Markup; Leave blank for no markup'
    },
    conditionSection: {
      title: 'When the following conditions are met, automatically match rate information',
      groupRelAnd: 'AND',
      groupRelOr: 'OR',
      groupInnerRelation: 'Within Group',
      groupOuterRelation: 'With Previous Group',
      addCondition: 'Add Condition',
      addGroup: 'Add Condition Group',
      maxConditionsTooltip: 'Maximum {count} conditions supported'
    },
    markupSection: {
      title: 'Then apply markup (based on matched ocean freight currency)',
      addBoxType: 'Add Box Type'
    },
    messages: {
      maxConditions: 'Maximum {count} conditions per rule',
      allBoxTypesAdded: 'All box types have been added',
      saveSuccess: 'Business increase rule created successfully!',
      updateSuccess: 'Business increase rule updated successfully!',
      copySuccess: 'Business increase rule copied. Rule ID will be regenerated. Please verify before saving.',
      loadFailed: 'Failed to load the business increase rule. Please try again later.',
      copyLoadFailed: 'Failed to load the rule to copy. Please try again later.',
      saveFailed: 'Save failed. Check the required fields.'
    }
  },

  // Sales Markup Rules List
  salesMarkup: {
    autoMatch: 'Match each rate automatically',
    businessType: 'Business type',
    types: { FCL: 'FCL', LCL: 'LCL', RORO: 'Ro-ro', BULK: 'Breakbulk', RAIL: 'Rail', EXPRESS: 'Express', AIR: 'Air', PRE_PORT: 'Pre-port', LAST_MILE: 'Last mile' },
    markup: 'Markup',
    exportFilename: 'Sales Markup Rules List',
    toolbar: {
      addRule: 'Add Rule',
      batchEnableCount: 'Batch Enable ({count})',
      batchDisableCount: 'Batch Disable ({count})',
      batchDeleteCount: 'Batch Delete ({count})'
    },
    columns: {
      rulesId: 'Rule ID',
      ruleName: 'Rule Name',
      priority: 'Priority',
      condition: 'Markup Condition',
      fclEnable: 'FCL',
      lclEnable: 'LCL',
      airEnable: 'Air',
      prePortEnable: 'Pre-carriage',
      lastMileEnable: 'Last Mile',
      enabled: 'Status',
      dateCreated: 'Created Date',
      dateModified: 'Modified Date',
      createdBy: 'Created By',
      modifiedBy: 'Modified By',
      actions: 'Actions'
    },
    status: {
      enabled: 'Enabled',
      disabled: 'Disabled'
    },
    scopeType: {
      specificClient: 'Specific Client',
      clientLevel: 'Client Level',
      all: 'All'
    },
    condition: {
      scope: 'Scope',
      carrier: 'Carrier',
      airline: 'Airline',
      route: 'Discharge Port Route',
      pol: 'POL',
      pod: 'Port of Discharge',
      polAirport: 'Departure Airport',
      podAirport: 'Destination Airport'
    },
    actions: {
      view: 'View',
      edit: 'Edit',
      more: 'More',
      copy: 'Copy',
      delete: 'Delete'
    },
    modal: {
      confirmEnable: 'Confirm Enable',
      confirmDisable: 'Confirm Disable',
      enableContent: 'Are you sure you want to enable this rule?',
      disableContent: 'Are you sure you want to disable this rule?',
      deleteTitle: 'Confirm Delete',
      deleteContent: 'Are you sure you want to delete this rule? This action cannot be undone.',
      deleteOkText: 'Confirm Delete',
      batchEnableTitle: 'Batch Enable Confirmation',
      batchEnableContent: 'Are you sure you want to enable the selected {count} rule(s)?',
      batchDisableTitle: 'Batch Disable Confirmation',
      batchDisableContent: 'Are you sure you want to disable the selected {count} rule(s)?',
      batchDeleteTitle: 'Batch Delete Confirmation',
      batchDeleteContent: 'Are you sure you want to delete the selected {count} rule(s)? This action cannot be undone.',
      batchDeleteOkText: 'Confirm Delete',
      confirm: 'Confirm',
      cancel: 'Cancel'
    },
    messages: {
      loadFailed: 'Failed to load data',
      missingId: 'Missing record ID',
      enableSuccess: 'Enabled successfully',
      disableSuccess: 'Disabled successfully',
      deleteSuccess: 'Deleted successfully',
      batchEnableSuccess: 'Successfully enabled {count} rule(s)',
      batchDisableSuccess: 'Successfully disabled {count} rule(s)',
      batchDeleteSuccess: 'Successfully deleted {count} rule(s)',
      selectEnableRules: 'Please select rules to enable first',
      selectDisableRules: 'Please select rules to disable first',
      selectDeleteRules: 'Please select rules to delete first'
    }
  },

  // Sales Markup Rules Detail
  salesMarkupDetail: {
    pageTitle: {
      copy: 'Copy Sales Markup Rule',
      create: 'Add Sales Markup Rule',
      edit: 'Edit Sales Markup Rule',
      view: 'Sales Markup Rule Detail'
    },
    ruleStatus: 'Rule Status:',
    status: {
      enabled: 'Enabled',
      disabled: 'Disabled'
    },
    buttons: {
      back: 'Back',
      save: 'Save',
      edit: 'Edit',
      copy: 'Copy'
    },
    copyAlert: 'Copying sales markup rule. The rule ID will be auto-generated. Please verify all information before saving.',
    basicInfo: {
      title: 'Basic Information',
      ruleId: 'Rule ID',
      ruleName: 'Rule Name',
      priority: 'Priority'
    },
    conditionSection: {
      title: 'Markup Conditions',
      hint: 'All conditions below are optional. Leave blank means no restriction. Multiple conditions are combined with AND logic.',
      scopeType: 'Applicable Scope',
      clients: 'Select Clients',
      clientLevels: 'Select Levels',
      carrier: 'Carrier',
      airline: 'Airline',
      route: 'Discharge Port Route',
      pol: 'POL',
      pod: 'Port of Discharge',
      polAirport: 'Departure Airport',
      podAirport: 'Destination Airport'
    },
    businessSection: {
      title: 'Business Type Markup Configuration',
      hint: 'One rule applies to one business type. Changes only affect that type.',
      fcl: 'Enable FCL Markup',
      lcl: 'Enable LCL Markup',
      air: 'Enable Air Markup',
      prePort: 'Enable Pre-carriage Markup',
      lastMile: 'Enable Last Mile Markup'
    },
    placeholders: {
      ruleName: 'Please enter rule name',
      priority: 'Higher value = higher priority, default 100',
      scopeType: 'Please select applicable scope',
      clients: 'Please select clients',
      clientLevels: 'Please select client levels',
      carrier: 'Please select carrier',
      airline: 'Please select airline',
      route: 'Please select discharge port route',
      pol: 'Please select POL',
      pod: 'Please select discharge port',
      polAirport: 'Please select departure airport',
      podAirport: 'Please select destination airport',
      config: 'Please enter markup configuration (JSON)'
    },
    validation: {
      ruleName: 'Please enter rule name',
      priority: 'Please enter priority',
      clientIds: 'Please select clients',
      clientLevels: 'Please select client levels'
    },
    hints: {
      priority: 'Higher value = higher priority, default 100'
    },
    messages: {
      loadFailed: 'Failed to load data',
      saveSuccess: 'Sales markup rule created successfully!',
      updateSuccess: 'Sales markup rule updated successfully!',
      copySuccess: 'Sales markup rule copied. Rule ID will be regenerated. Please verify before saving.',
      checkRequired: 'Please check required fields'
    },
    businessConfig: {
      markupMethod: 'Markup Method',
      perContainer: 'Per Container',
      perUnit: 'Per Unit',
      markupType: 'Markup Type',
      amount: 'Amount',
      percentage: 'Percentage',
      percentageHint: 'e.g. 5 means 5%',
      containerConfig: 'Container Markup Config',
      addContainer: 'Add Container',
      selectContainer: 'Select Container',
      containerEmpty: 'Click "Add Container" to configure markup per container type',
      unitPrice: 'Unit Price Markup',
      amountPlaceholder: 'Markup Amount',
      percentagePlaceholder: 'Markup Percentage',
      airMatrix: 'Density × Weight Break Markup Matrix',
      addDensityLevel: 'Add Density Range',
      selectDensity: 'Select density range',
      airMatrixHint: 'Values use the same unit as base air freight; leave blank for no markup',
      airMatrixEmpty: 'Click "Add Density Range" to configure the markup matrix',
      densityInterval: 'Density Range',
      actions: 'Actions'
    }
  },
  businessSea: {
    tabTitle: 'Ocean Freight',
    pageTitles: {
      create: 'Create Ocean Business Markup Rule',
      edit: 'Edit Ocean Business Markup Rule',
      view: 'View Ocean Business Markup Rule'
    },
    sections: {
      basic: 'Rule Information',
      conditions: 'Match Conditions',
      markups: 'Markup by Business Type'
    },
    fields: {
      rulesId: 'Rule ID',
      businessTypes: 'Business Types',
      ruleName: 'Rule Name',
      rulePriority: 'Priority',
      companyIds: 'Companies',
      validity: 'Validity',
      increasePriceType: 'Markup Value Type',
      containerTypes: 'Container Types',
      percentageValue: 'Common Markup Percentage',
      unitMarkup: 'Unit Price Markup'
    },
    businessTypes: {
      fcl: 'FCL',
      lcl: 'LCL',
      roro: 'RoRo',
      bulk: 'Break Bulk'
    },
    conditionFields: {
      carrier: 'Carrier',
      pol: 'Port of Loading (POL)',
      pod: 'Port of Discharge (POD)',
      routeCategory: 'POD Route Category',
      supplier: 'Supplier',
      contractNo: 'Contract No.',
      nac: 'NAC',
      cargoType: 'Cargo Type',
      por: 'Place of Receipt (POR)',
      pdl: 'Place of Delivery (PDL)',
      directFlag: 'Direct / Transit',
      transitPort: 'Transit Port',
      containerOwner: 'Container Owner',
      polWharf: 'POL Terminal',
      podWharf: 'POD Terminal',
      polCountry: 'Origin Country',
      pdlCountry: 'Destination Country',
      polCity: 'Origin City',
      pdlCity: 'Destination City',
      routeCode: 'Route Code'
    },
    conditionValues: {
      direct: 'Direct',
      transit: 'Transit',
      unspecified: 'Unspecified',
      coc: 'COC - Carrier-Owned',
      soc: 'SOC - Shipper-Owned'
    },
    conditions: {
      hint: 'Conditions within a group and relations between groups both support AND/OR. Each group relation connects it to the previous group and is evaluated in display order. Enter multiple values as tags.',
      groupTitle: 'Condition Group {index}',
      groupInnerRelation: 'Within Group',
      groupOuterRelation: 'With Previous Group',
      and: 'AND',
      or: 'OR',
      in: 'Includes',
      notIn: 'Excludes',
      isEmpty: 'Is empty',
      isNotEmpty: 'Is not empty'
    },
    markupTypes: {
      perContainer: 'Per Container Type',
      perUnit: 'Per Unit'
    },
    priceTypes: {
      amount: 'Fixed Amount',
      percentage: 'Percentage'
    },
    markups: {
      selectBusinessTypeFirst: 'Select at least one business type before configuring markups.',
      title: 'Base Ocean Freight Markup',
      amount: 'Amount',
      addColumns: 'Add Container Columns',
      removeColumn: 'Remove {container} Column',
      containerValue: '{container} Markup',
      unitPrice: 'Unit Price Markup',
      notApplicable: '-',
      currencyHint: 'Markup currency follows the base freight currency',
      percentageHint: 'Percentage value, e.g. 5 means 5%',
      methodHint: 'FCL uses container markups; LCL, RoRo and Break Bulk use unit price markups',
      containerHint: 'Select the container columns for this rule. Unselected containers receive no markup.'
    },
    status: {
      enabled: 'Enabled',
      disabled: 'Disabled',
      expired: 'Expired'
    },
    list: {
      exportFilename: 'Ocean Business Markup Rules',
      conditionsCount: '{count} matching conditions',
      markupsCount: '{count} markup entries',
      perUnitValue: '{value}/unit',
      unlimited: 'No restriction',
      moreItems: '{count} more',
      notConfigured: 'Not configured',
      longTermActive: 'Long-term',
      longTerm: 'Long-term',
      columns: {
        rulesId: 'Rule ID',
        businessTypes: 'Business Types',
        ruleName: 'Rule Name',
        companyIds: 'Companies',
        rulePriority: 'Priority',
        conditions: 'Conditions',
        markupAmounts: 'Markup Amounts',
        status: 'Status',
        validity: 'Validity',
        createdBy: 'Created By',
        dateCreated: 'Created At',
        modifiedBy: 'Modified By',
        dateModified: 'Modified At',
        actions: 'Actions'
      }
    },
    actions: {
      add: 'Add Rule',
      batchEnable: 'Enable ({count})',
      batchDisable: 'Disable ({count})',
      batchValidity: 'Adjust Validity ({count})',
      batchDelete: 'Delete ({count})',
      view: 'View',
      edit: 'Edit',
      more: 'More',
      disable: 'Disable',
      enable: 'Enable',
      delete: 'Delete',
      removeGroup: 'Remove Group',
      removeCondition: 'Remove Condition',
      insertCondition: 'Insert Condition Below',
      convertToGroup: 'Add Condition Group',
      addCondition: 'Add Condition',
      addGroup: 'Add Group',
      save: 'Save',
      cancel: 'Cancel',
      confirm: 'Confirm'
    },
    batchValidity: {
      title: 'Adjust Validity in Batch',
      selectedCount: '{count} rules selected. Their validity periods will be updated together.',
      validityRange: 'New Validity Period',
      startDate: 'Select the start date',
      endDate: 'Select the end date',
      required: 'Select a complete validity period',
      invalidRange: 'The end date cannot be earlier than the start date'
    },
    placeholders: {
      autoGenerated: 'Generated after saving',
      ruleName: 'Enter rule name',
      rulePriority: 'Enter a value from 1 to 9999',
      companyIds: 'Select companies',
      beginDate: 'Select start time',
      endDate: 'Select end time',
      conditionField: 'Select a condition field',
      conditionValue: 'Enter a value and press Enter',
      containerTypes: 'Select container types',
      markupValue: 'Enter markup value',
      rulesId: 'Enter rule ID',
      pod: 'Select POD',
      increasePriceType: 'Select markup value type',
      status: 'Select status',
      validity: 'Select validity',
      dateCreated: 'Select created date range',
      dateModified: 'Select modified date range'
    },
    validation: {
      businessTypes: 'Select at least one business type',
      ruleName: 'Enter the rule name',
      rulePriority: 'Enter the rule priority',
      companyIds: 'Select companies',
      validity: 'Select a complete validity range',
      conditions: 'Enter at least one value for every match condition',
      containerMarkups: 'Configure at least one container type and its markup',
      unitMarkup: 'Enter the unit price markup'
    },
    messages: {
      companyLoadFailed: 'Failed to load operating companies. Try again later.',
      containerLoadFailed: 'Failed to load container types. Common types remain available.',
      missingId: 'The rule ID is missing.',
      loadFailed: 'Failed to load the business markup rule. Try again later.',
      saveSuccess: 'The business markup rule was created in Disabled status.',
      updateSuccess: 'The business markup rule was updated.',
      saveFailed: 'Failed to save the business markup rule. Check the form and try again.',
      clickTabToLoad: 'Click the tab to load its content.',
      noVisibleTabs: 'Your account cannot access any business markup type.',
      noTabPermission: 'Your account cannot access this business markup type.',
      noActionPermission: 'Your account cannot perform this action.',
      disableSuccess: 'The rule was disabled.',
      enableSuccess: 'The rule was enabled.',
      operationFailed: 'The operation failed. Try again later.',
      deleteSuccess: 'The rule was deleted.',
      batchEnableSuccess: 'The selected rules were enabled.',
      batchDisableSuccess: 'The selected rules were disabled.',
      batchValiditySuccess: 'The validity period was updated for {count} rules.',
      batchValidityFailed: 'Failed to adjust the validity period. Try again later.',
      batchDeleteSuccess: 'The selected rules were deleted.'
    },
    confirm: {
      disableTitle: 'Disable Rule',
      disableContent: 'The rule will no longer participate in price calculation. Continue?',
      enableTitle: 'Enable Rule',
      enableContent: 'The rule will participate in price calculation during its validity period. Continue?',
      deleteTitle: 'Delete Rule',
      deleteContent: 'This operation cannot be undone. Continue?',
      batchEnableTitle: 'Enable Selected Rules',
      batchEnableContent: 'Enable the selected {count} rules?',
      batchDisableTitle: 'Disable Selected Rules',
      batchDisableContent: 'Disable the selected {count} rules?',
      batchDeleteTitle: 'Delete Selected Rules',
      batchDeleteContent: 'Delete the selected {count} rules? This operation cannot be undone.'
    }
  },
  businessOther: {
    routeTitle: 'Business Markup Rule Details',
    businessTypes: {
      preport: 'Pre-carriage',
      lastmile: 'Last Mile',
      air: 'Air Freight',
      rail: 'Rail Freight',
      express: 'Express'
    },
    pageTitles: {
      create: 'Create {type} Business Markup Rule',
      edit: 'Edit {type} Business Markup Rule',
      view: 'View {type} Business Markup Rule'
    },
    sections: {
      markups: 'Markup Amounts'
    },
    conditionFields: {
      supplier: 'Supplier',
      cargoType: 'Cargo Type',
      containerOwner: 'Container Owner',
      transportMode: 'Transport Mode',
      originCountry: 'Origin Country',
      originProvince: 'Origin State / Province',
      originCity: 'Origin City',
      originDistrict: 'Origin District',
      originTown: 'Origin Town',
      originCommunity: 'Origin Community',
      originAddress: 'Origin Address',
      zipCode: 'Postal Code',
      originWarehouseType: 'Origin Warehouse Type',
      originWarehouse: 'Origin Warehouse',
      pol: 'Port of Loading',
      polWharf: 'POL Terminal',
      loadingStation: 'Loading Station',
      departureAirport: 'Departure Airport',
      airportCargoStation: 'Airport Cargo Terminal',
      dischargePort: 'Discharge Port',
      dischargeWharf: 'Discharge Terminal',
      dischargeStation: 'Discharge Station',
      dischargeAirport: 'Discharge Airport',
      deliveryCountry: 'Delivery Country',
      deliveryProvince: 'Delivery State / Province',
      deliveryCity: 'Delivery City',
      deliveryDistrict: 'Delivery District',
      deliveryAddress: 'Delivery Address',
      deliveryWarehouseType: 'Delivery Warehouse Type',
      deliveryWarehouse: 'Delivery Warehouse',
      airline: 'Airline',
      packageType: 'Package Type',
      routeLevel: 'Route Level',
      contractNo: 'Contract No.',
      nac: 'NAC',
      destCountry: 'Destination Country',
      destProvince: 'Destination State / Province',
      destCity: 'Destination City',
      destDistrict: 'Destination District',
      destAddress: 'Destination Address',
      destAirport: 'Destination Airport',
      destAirportRoute: 'Destination Airport Route',
      directFlag: 'Direct / Transit',
      flightNo: 'Flight No.',
      railwayCompany: 'Railway Company',
      departureStation: 'Departure Station',
      destStation: 'Destination Station',
      exitPort: 'Exit Port',
      entryPort: 'Entry Port',
      transitClause: 'Transit Clause',
      transitStation: 'Transit Station',
      routeCategory: 'Route Category',
      loadMode: 'Load Mode',
      expressCompany: 'Express Carrier',
      expressAccount: 'Express Account',
      serviceType: 'Service Type'
    },
    conditionValues: {
      truck: 'Truck',
      barge: 'Barge',
      rail: 'Rail'
    },
    fields: {
      markupMethods: 'Markup Methods',
      densityLevel: 'Density Level',
      railModes: 'Transport Modes',
      vehicleType: 'Vehicle Type',
      basePrice1: 'Starting Base Price',
      basePrice2: 'Distance Base Price',
      unitPrice: 'Unit Price',
      minPrice: 'Minimum Price',
      maxPrice: 'Maximum Price',
      expressModels: 'Billing Models',
      firstWeightPrice: 'First-weight Price',
      additionalWeightPrice: 'Additional-weight Price',
      startWeight: 'Start Weight',
      endWeight: 'End Weight',
      additionalUnitPrice: 'Additional Unit Markup'
    },
    markupMethods: {
      perContainer: 'Per Container Type',
      perUnit: 'Per Unit Price'
    },
    markups: {
      amountHint: 'Markup currency follows the base charge currency',
      airModeHint: 'Complete every uniform weight break, or every weight break in each configured density row',
      containerEmpty: 'Click "Add Container Columns" to configure markup by container type'
    },
    railModes: {
      container: 'Container',
      ftl: 'Full Truckload',
      ltl: 'Less-than-Truckload'
    },
    expressModels: {
      firstAdditional: 'First + Additional Weight',
      unitPrice: 'Unit Price',
      weightTier: 'Weight Tiers'
    },
    airDensity: {
      all: 'All Densities',
      level0To166: '0-166',
      level166To200: '166-200',
      level200To250: '200-250',
      level250To300: '250-300',
      level300To400: '300-400',
      level400To500: '400-500',
      level500Plus: '500+'
    },
    actions: {
      addDensity: 'Add Density Level',
      addVehicle: 'Add Vehicle Type',
      addWeightTier: 'Add Weight Tier'
    },
    placeholders: {
      containerTypes: 'Select container types',
      vehicleType: 'Select a vehicle type from platform business data',
      noUpperLimit: 'Leave blank for no upper limit'
    },
    validation: {
      markupMethods: 'Select at least one markup method',
      containerMarkups: 'Configure at least one container type and its markup',
      unitMarkup: 'Enter the unit price markup',
      airMatrix: 'Complete the current air markup matrix',
      airMatrixCell: 'Enter a non-negative number for weight break "{tier}" at density "{density}"',
      railModes: 'Select at least one rail transport mode',
      railFtl: 'Configure at least one rail vehicle type',
      railVehicleRequired: 'Select a rail vehicle type',
      railVehicleDuplicate: 'The same rail vehicle type cannot be configured more than once',
      railVehicleNotConfigured: 'No active rail vehicle types are configured in platform business data',
      railVehicleInvalid: 'The rule contains an inactive or missing rail vehicle type. Select it again.',
      railLtl: 'Configure the rail LTL markup',
      expressModels: 'Select at least one express billing model',
      expressTiers: 'Configure at least one express weight tier',
      expressValue: 'Enter a non-negative value for "{field}" with at most two decimal places',
      expressTierValue: 'Enter a non-negative value for "{field}" in weight tier {row}, with at most two decimal places',
      expressTierBoundary: 'The end weight in tier {row} must be greater than its start weight',
      expressTierOpenEnd: 'Weight tier {row} has no upper limit and must be last when sorted by start weight',
      expressTierOverlap: 'Weight tier {row} overlaps another tier. Adjust its start or end weight'
    },
    summary: {
      airDensityRows: '{count} density levels configured',
      airUniform: 'Uniform weight-break markups',
      railFtlRows: '{count} vehicle types configured',
      railLtl: 'Unit, minimum, and maximum price markups',
      expressTierRows: '{count} weight tiers configured'
    },
    messages: {
      typeMismatch: 'The rule business type does not match this page.',
      typeInvalid: 'This business rule type is not supported.',
      railVehicleNotConfigured: 'No active rail vehicle types are configured in platform business data.',
      railVehicleLoadFailed: 'Failed to load rail vehicle types. Try again later.'
    },
    confirm: {
      disableTitle: 'Disable Rule',
      disableContent: 'The rule status will change to Disabled. Continue?',
      enableTitle: 'Enable Rule',
      enableContent: 'The rule status will change to Enabled. Continue?',
      deleteTitle: 'Delete Rule',
      deleteContent: 'This operation cannot be undone. Continue?',
      batchEnableTitle: 'Enable Selected Rules',
      batchEnableContent: 'Enable the selected {count} rules?',
      batchDisableTitle: 'Disable Selected Rules',
      batchDisableContent: 'Disable the selected {count} rules?',
      batchDeleteTitle: 'Delete Selected Rules',
      batchDeleteContent: 'Delete the selected {count} rules? This operation cannot be undone.'
    },
    list: {
      exportFilename: '{type} Business Markup Rules'
    }
  }
}
